<template>
		<div class="welcome-login text-center">
			<!-- display the district info -->
			<img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'" />
			<h3 class="district-name">{{ districtName }}</h3>
			<hr />
			<div class="row">
				<div class="col-md-12">
					<h3>Go to <br/> <small>{{clientName}}</small></h3>
					<p class="text-left">{{message}}</p>
					<p class="text-left">You can manage access on your Sapphire Community Portal Third Party Access screen.</p>

					<hr/>
				</div>
			</div>
			<form
				method="post"
				ref="form"
				:action="approveEndPoint">
				<div class="row">
					<div class="col-md-6">
						<a :href="cancelEndPoint" class="btn btn-block btn-default">
							Cancel
						</a>
					</div>
					<div class="col-md-6">
						<button type="submit" class="btn btn-block btn-primary">
							Continue
						</button>
					</div>
				</div>
			</form>
		</div>
</template>

<script>
export default {
	props:{
		districtName: "",
		logoSrc: "",
		approveEndPoint: "",
		cancelEndPoint: "",
		
		clientName: {
			type: String,
			required: false,
			default: "Third Party Site",
		},
		csrfToken: "",
		message: "",
	}
}
</script>
